import * as Action from './definitions/action';
import * as Asset from './definitions/asset';
import * as Chart from './definitions/chart';
import * as Table from './definitions/table';
import * as File from './definitions/file';
import * as Messaging from './definitions/messaging';
import * as Form from './definitions/form';
import * as Text from './definitions/text';
import * as User from './definitions/user';
import * as Nav from './definitions/nav';
import * as Custom from './definitions/custom';
import * as Badge from './definitions/badge';
import * as Status from './definitions/status';
import * as Heading from './definitions/heading';

import { createIconSet } from './util';

export const actionIcons = createIconSet(Action);
export const assetIcons = createIconSet(Asset);
export const chartIcons = createIconSet(Chart);
export const tableIcons = createIconSet(Table);
export const fileIcons = createIconSet(File);
export const messagingIcons = createIconSet(Messaging);
export const formIcons = createIconSet(Form);
export const textIcons = createIconSet(Text);
export const userIcons = createIconSet(User);
export const navIcons = createIconSet(Nav);
export const customIcons = createIconSet(Custom);
export const badgeIcons = createIconSet(Badge);
export const statusIcons = createIconSet(Status);
export const headingIcons = createIconSet(Heading);

export const allIcons = {
  ...actionIcons,
  ...assetIcons,
  ...chartIcons,
  ...tableIcons,
  ...fileIcons,
  ...messagingIcons,
  ...formIcons,
  ...textIcons,
  ...userIcons,
  ...navIcons,
  ...customIcons,
  ...badgeIcons,
  ...statusIcons,
  ...headingIcons,
};

type ActionValidIcons = `${Action.SemanticCategoryName}-${Action.ValidIcons}`;
type AssetValidIcons = `${Asset.SemanticCategoryName}-${Asset.ValidIcons}`;
type ChartValidIcons = `${Chart.SemanticCategoryName}-${Chart.ValidIcons}`;
type TableValidIcons = `${Table.SemanticCategoryName}-${Table.ValidIcons}`;
type FileValidIcons = `${File.SemanticCategoryName}-${File.ValidIcons}`;
type MessagingValidIcons =
  `${Messaging.SemanticCategoryName}-${Messaging.ValidIcons}`;
type FormValidIcons = `${Form.SemanticCategoryName}-${Form.ValidIcons}`;
type TextValidIcons = `${Text.SemanticCategoryName}-${Text.ValidIcons}`;
type UserValidIcons = `${User.SemanticCategoryName}-${User.ValidIcons}`;
type NavValidIcons = `${Nav.SemanticCategoryName}-${Nav.ValidIcons}`;
type CustomValidIcons = `${Custom.SemanticCategoryName}-${Custom.ValidIcons}`;
type BadgeValidIcons = `${Badge.SemanticCategoryName}-${Badge.ValidIcons}`;
type StatusValidIcons = `${Status.SemanticCategoryName}-${Status.ValidIcons}`;
type HeadingValidIcons =
  `${Heading.SemanticCategoryName}-${Heading.ValidIcons}`;

export type ValidIcons =
  | ActionValidIcons
  | AssetValidIcons
  | ChartValidIcons
  | TableValidIcons
  | FileValidIcons
  | MessagingValidIcons
  | FormValidIcons
  | TextValidIcons
  | UserValidIcons
  | NavValidIcons
  | CustomValidIcons
  | BadgeValidIcons
  | StatusValidIcons
  | HeadingValidIcons;
